import React, { Suspense } from 'react';
import { Box, Loader } from '@wix/design-system';
const MarkdownWrapper = /*#__PURE__*/React.lazy(async () => {
  const mdwrpModule = await import('./MarkdownWrapper');
  return {
    default: mdwrpModule.MarkdownWrapper
  };
});
export const CodeMDWidget = _ref => {
  let {
    data: {
      markdownWithCode,
      style,
      linkButton,
      language
    }
  } = _ref;
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      align: "center",
      padding: "10px",
      width: "100%"
    }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Loader, {
      size: "tiny",
      text: "Loading Code"
    })))
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    className: "code-widget",
    maxWidth: "95%",
    width: "95%"
  }, /*#__PURE__*/React.createElement(MarkdownWrapper, {
    markdownWithCode: markdownWithCode,
    style: style,
    linkButton: linkButton,
    language: language
  })));
};
export const CODE_MARKDOWN_WIDGET = 'CODE_MARKDOWN_WIDGET';
//# sourceMappingURL=codeMDWidget.js.map